import { render, staticRenderFns } from "./VerificationInfoB.vue?vue&type=template&id=5a8f4fb0"
import script from "./VerificationInfoB.vue?vue&type=script&lang=js"
export * from "./VerificationInfoB.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports